import { useState } from "react";
import { includes } from "lodash";

import Icon from "@assets/icon_config";
import { getReportUpdatedDateTime } from "@utils/helpers";
import StarComponent from "./star";

const Card = (props: {
  lastUpdatedDate: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
  // description: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
  description: string;
  name: string;
  handleClick: React.MouseEventHandler<HTMLDivElement> | undefined;
  type: string;
  starred: any;
  searchedKeyWord: string;
  reportValue: any;
  updateReport: any;
}) => {
  const [isHovering, setIsHovering] = useState(false);

  let str1 = props.name;
  let str2 = "";
  let str3 = "";

  const name = props.name?.toLowerCase();
  const word = props.searchedKeyWord?.toLowerCase();

  // This If block is used to highlight the string search
  if (includes(name, word)) {
    const index = name.indexOf(word);
    const lastIndex = index + word?.length;

    str1 = props.name.substring(0, index);
    str2 = props.name.substring(lastIndex, props.name.length);
    str3 = props.name.substring(index, lastIndex);
  }

  return (
    <div className="ui-dashboard-card" onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} onClick={props.handleClick}>
      {isHovering ? (
        <div className="ui-dashboard-card__hovered">
          <div className="ui-dashboard-card__hovered__section-1">
            <div className="ui-dashboard-card__hovered__section-1__title">
              {str1}
              <span className="ui-dashboard-card__hovered__section-1__title__name">{str3}</span>
              {str2}
            </div>
            <div className="ui-dashboard-card__hovered__section-1__star">
              <StarComponent
                starred={props.starred}
                reportValue={props.reportValue}
                className="ui-dashboard-card__content__bookmark"
                starFilledSize={20}
                starOutlinedSize={20}
                update={props.updateReport}
              />
            </div>
          </div>
          <div className="ui-dashboard-card__hovered__description" style={{ height: props.name.length > 25 ? "55%" : "73%" }}>
            {props?.description}
          </div>
        </div>
      ) : (
        <div className="ui-dashboard-card__content">
          <div className="ui-dashboard-card__content__header">
            <div className="ui-dashboard-card__content__header__section-1">
              <div className="ui-dashboard-card__content__header__section-1__icon">
                <Icon name={props.type === "Report" ? "report-with-background" : "dashboard-with-background"} stroke={isHovering ? "#7793D9" : undefined} />
              </div>
              <div className="ui-dashboard-card__content__header__section-1__name">
                {str1}
                <span className="ui-dashboard-card__content__header__section-1__name__bold">{str3}</span>
                {str2}
              </div>
            </div>
            <div className="ui-dashboard-card__content__header__section-2"></div>
          </div>
          <div className="ui-dashboard-card__content__footer">
            <div className="ui-dashboard-card__content__footer__last-update">
              {`Updated: `}{" "}
              <span className="ui-dashboard-card__content__footer__last-update__bold">{!props.lastUpdatedDate ? "NA" : getReportUpdatedDateTime(props.lastUpdatedDate , true)}</span>
            </div>
            <div className="ui-dashboard-card__content__footer__last-update__star">
              <StarComponent
                starred={props.starred}
                reportValue={props.reportValue}
                className="ui-dashboard-card__content__header__section-2__bookmark"
                starFilledSize={13}
                starOutlinedSize={13}
                starFilledColor={"#3665D9"}
                update={props.updateReport}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;
